import actions from "./actions";
import mutations from "./mutations";

export const showComponentsModule = {
  state: {
    showEditSelection: false,
    showJumpToPickNr: false,
    showEditDrives: false,
    showEditPicks: false,
    showInfoComponent: false
  },
  namespaced: true,
  getters: {},
  actions,
  mutations
};
